/**
 * Cart Backorder Attribute Sync - Moon Moon Agency
 * Maintient l'attribut de panier privé __has_backorder (lu par une Delivery Customization Function).
 * Vérité calculée en Liquid dans MM-Cart.liquid → exposée via [data-cart-has-backorder].
 */

/*********************************************************************************************
 * 🛒 CART BACKORDER MANAGER
 */
const CartBackorderManager = {
	config: {
		selectors: { flag: '[data-cart-has-backorder]' },
		attributeKey: '__has_backorder',
		storageKey: 'mm_has_backorder',
		debounceDelay: 400,
	},

	_lastSent: null,

	init() {
		// Valeur déjà écrite lors d'une navigation précédente (même session) → évite un POST redondant
		this._lastSent = sessionStorage.getItem(this.config.storageKey);
		this._syncDebounced = window.debounce(() => this._sync(), this.config.debounceDelay);

		// Re-render serveur de la section cart (ajout, suppression, qty, vidage)
		document.addEventListener('cart:refreshed', this._syncDebounced);

		// Premier rendu
		this._sync();
		window.log('info', '🛒 [BACKORDER]', 'Initialized');
	},

	_readFlag() {
		const el = window.getElement(this.config.selectors.flag);
		if (!el) return null; // pas de panier dans le DOM
		return el.dataset.cartHasBackorder === 'true' ? 'true' : 'false';
	},

	async _sync() {
		const value = this._readFlag();
		if (value === null || value === this._lastSent) return; // anti-boucle : pas de changement → pas d'écriture

		const previous = this._lastSent;
		this._lastSent = value; // optimiste : bloque les envois concurrents identiques

		try {
			const baseUrl = window.Shopify?.routes?.root || '/';
			// Pas de `sections` → pas de refreshDOM → pas de re-déclenchement de cart:refreshed
			await fetch(`${baseUrl}cart/update.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ attributes: { [this.config.attributeKey]: value } }),
			});
			try { sessionStorage.setItem(this.config.storageKey, value); } catch (e) {}
			window.emit('global:backorder-synced', { value });
			window.log('info', '🛒 [BACKORDER]', `Synced __has_backorder=${value}`);
		} catch (error) {
			this._lastSent = previous; // rollback → retry au prochain event
			window.log('error', '🛒 [BACKORDER]', 'Sync failed', { error: error.message });
		}
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => CartBackorderManager.init());
} else {
	CartBackorderManager.init();
}
